module.exports = __webpack_public_path__ + "img/meguru04.6b7f0a7a.png";